var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#06C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.67 2.338c.217.363.62.606 1.08.606.69 0 1.25-.547 1.25-1.222C11 1.047 10.44.5 9.75.5S8.5 1.047 8.5 1.722c0 .225.062.435.17.616Zm0 0L3.33 5.384m0 0a1.255 1.255 0 0 0-1.08-.606C1.56 4.778 1 5.325 1 6c0 .675.56 1.222 1.25 1.222.46 0 .863-.243 1.08-.606m0-1.232a1.196 1.196 0 0 1 0 1.232m0 0 5.34 3.046m0 0c.217-.363.62-.606 1.08-.606.69 0 1.25.547 1.25 1.222 0 .675-.56 1.222-1.25 1.222s-1.25-.547-1.25-1.222c0-.225.062-.435.17-.616Z"
  })));
};
export default SvgShare;